<template>
    <div>
        <div class="row">
            <div class="small-12 columns">
                <div id="airlines_not_loaded_error" v-if="errorInformation.showAirlinesLoadError">
                    <div class="alert-box alert">
                        <h3 class="white-text">Fehler</h3>
                        <p class="white-text">
                            Leider ist ein Fehler aufgetreten und die Liste der Fluggesellschaften konnte nicht geladen
                            werden.
                            Bitte versuchen Sie es erneut.
                            Bei anhaltenden Problemen kontaktieren Sie uns unter <a href="mailto:info@ratis.de">info@ratis.de</a>
                            und
                            teilen uns bitte die genaue Fehlermeldung mit.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="small-12 columns">
                <div id="general_error" v-if="errorInformation.showGeneralError">
                    <div class="alert-box alert">
                        <h3 class="white-text">Fehler</h3>
                        <p class="white-text">
                            Leider ist ein Fehler aufgetreten ({{ errorInformation.generalErrorMessage }}).
                            Bitte versuchen Sie es erneut.
                            Bei anhaltenden Problemen kontaktieren Sie uns unter <a href="mailto:info@ratis.de">info@ratis.de</a>
                            und
                            teilen uns bitte die genaue Fehlermeldung mit.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="small-12 columns">
                <div class="alert-box alert" v-if="errorInformation.showValidationError">
                    <p class="white-text">
                        <strong>Fehler beim Ausfüllen der Felder:</strong>
                        Leider sind nicht alle Formularfelder korrekt ausgefüllt.
                        Bitte kontrollieren Sie die rot markierten Felder.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Errors',
    props: {
        errorInformation: {
            type: Object,
            default: function ()
            {
                return {
                    showAirlinesLoadError: false,
                    showGeneralError: false,
                    generalErrorMessage: null,
                    showValidationError: false
                };
            }
        }
    }
};
</script>

<style scoped>
.white-text {
    color: white !important;
}
</style>